import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Grid, List, ListItem, ListItemText, MenuItem, Select } from '@material-ui/core';
import { ArrowDownIcon, TuneIcon, TocIcon, GoogleMapIcon } from '../../components/icons';
import CustomTypo from '../../components/CustomTypo';
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { domainName, portal_config } from '../../../portal.config'
import DrawerCustom from '../../components/DrawerCustom';
//import Slider from '@farbenmeer/react-spring-slider';
import { geocodeByAddress } from 'react-places-autocomplete';
//import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
//import { Carousel } from 'react-responsive-carousel';

import { CarouselProvider, Slider, Slide } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import Loading from '../../components/Loading';
import MapInputComponent from '../../components/MapInputComponent';
import t from '../../utils/translateUtil';

const styles = theme => ({
    root: {
        backgroundColor: theme.palette.background.main,
        //minHeight: window.innerHeight
        minHeight: '100vh',
    },
    content: {
        width: '100%',
    },
    right: {
        padding: theme.spacing(6),
    },
    loading: {
        marginTop: theme.spacing(4)
    },
    locationIcon: {
        position: 'absolute',
        bottom: theme.spacing(60),
        right: theme.spacing(0)
    },
    search: {
        // height: theme.spacing(10),
        // borderRadius: theme.spacing(10),
        // padding: theme.spacing(2, 8, 2, 4),
        // display: 'flex',
        alignItems: 'center',
        // backgroundColor: theme.palette.background.secondary,
        position: 'relative',
        //top:theme.spacing(2.6),
        //right:theme.spacing(14),
    },
    search_list: {
        backgroundColor: theme.palette.background.secondary,
        width: '98%',
        position: 'absolute',
        top: theme.spacing(10),
        marginLeft: '1%',
        borderBottomLeftRadius: theme.spacing(3),
        borderBottomRightRadius: theme.spacing(3),
        zIndex: 999
    },
    input: {
        marginLeft: theme.spacing(2),
        //flex: 1,
        width: '200%',
    },
    footer: {
        position: 'absolute',
        bottom: theme.spacing(4),
        right: theme.spacing(4),
        padding: theme.spacing(3),
    },
    cursor: {
        borderRadius: theme.spacing(4),
        cursor: "pointer",
        '&:hover': {
            backgroundColor: theme.palette.background.transparent,
            opacity: 0.7,
        },

    },
    tune: {
        position: 'absolute',
        right: theme.spacing(1),
        borderRadius: theme.spacing(4),
        cursor: "pointer",
        '&:hover': {
            backgroundColor: theme.palette.background.transparent,
            opacity: 0.7,
        },

    },
    selectBox: {
        width: theme.spacing(26),
        position: 'absolute',
        left: theme.spacing(3),
        cursor: "pointer",
        zIndex: 1000,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
    },
    selectCustomIcon: {
        marginTop: theme.spacing(1)
    },
    item_container: {
        width: 380,
        height: 120,
        padding: theme.spacing(0, 2, 0, 2),
        cursor: 'pointer'
    },
    item: {
        //backgroundColor: theme.palette.background.secondary,
        //borderRadius: theme.spacing(2)
    },
    item_image: {
        height: 120,
        width: '100%',
        objectFit: 'cover',
        borderTopLeftRadius: theme.spacing(2),
        borderBottomLeftRadius: theme.spacing(2),
    },
    item_right: {
        //width: '60%',
        //marginLeft: theme.spacing(2),
        //marginRight: '5%',
        padding: theme.spacing(4),
        backgroundColor: theme.palette.background.secondary,
        borderTopRightRadius: theme.spacing(2),
        borderBottomRightRadius: theme.spacing(2)
    },
    tag: {
        backgroundColor: theme.palette.background.tertiary,
        width: 40,
        padding: theme.spacing(1, 2, 1, 2),
        border: '1px solid',
        borderRadius: theme.spacing(4),
        borderColor: theme.palette.border.other,
        textAlign: "center",
    },
    merchant_image: {
        width: 48,
        height: 48,
        borderRadius: 48,
    },
    map_small: {
        width: '100%',
        height: '100%',
        position: 'relative',
    },
    header_small: {
        position: 'absolute',
        top: theme.spacing(24),
        padding: theme.spacing(0, 2, 2, 2)
    },
    toc_bg: {
        position: 'absolute',
        bottom: theme.spacing(6),
        right: theme.spacing(15),
        width: theme.spacing(12),
        height: theme.spacing(12),
        borderRadius: 56,
        backgroundColor: theme.palette.button.primary.backgroundColor,
        cursor: 'pointer'
    },
    drawerRight: {
        padding: theme.spacing(4)
    },
    google_map: {
        cursor: 'pointer'
    },
    input2: {
        //backgroundColor: '#000000',
        marginLeft: theme.spacing(2),
        flex: 1,
        width: '200%',
        [theme.breakpoints.down('lg')]: {
            width: '130%',
        },
        [theme.breakpoints.down('md')]: {
            width: '170%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '120%',
        },
        [theme.breakpoints.down('xs')]: {
            width: '130%',
        },
    },
});

class MapView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            search_value: '',
            merchantsByName: [],
            showList: false,
            markerSelected: null,
            openRightDrawer: false,
            selectSearch: 'google',
            searchSeleactData: [
                {
                    label: t('Google'),
                    value: 'google'
                },
                {
                    label: t('Merchant'),
                    value: 'merchant'
                }

            ]
        }
        this.onHandleChange = this.onHandleChange.bind(this);
        this.onSelectMaker = this.onSelectMaker.bind(this);
        this.onShowRightDrawer = this.onShowRightDrawer.bind(this)
        this.onSelectMerchant = this.onSelectMerchant.bind(this)
        this.onSelectAddress = this.onSelectAddress.bind(this)
        this.onSelectSearchChange = this.onSelectSearchChange.bind(this)
        this.onSelect = this.onSelect.bind(this)
    }
    onShowRightDrawer() {
        this.setState({ openRightDrawer: !this.state.openRightDrawer })
    }

    onSelectMerchant(venue) {
        this.setState({ openRightDrawer: true })
        this.props.onSelectMerchant(venue)
    }
    onHandleChange(value) {
        this.setState({ search_value: value });
        this.filterByName(value);
    }
    onSelectMaker(id) {
        this.setState({ markerSelected: id })
    }
    filterByName(name) {
        var merchants = this.props.merchants;
        //console.log(' filterByName merchants==',merchants)
        if (!name || !merchants) {
            this.setState({ merchantsByName: [], showList: false });
        } else {
            var merchantsByName = merchants.filter(merchant => {
                return merchant.name.toLowerCase().includes(name.toLowerCase());
            })

            if (merchantsByName.length == 0) {
                this.setState({ merchantsByName: [], showList: false });
            } else {
                this.setState({ merchantsByName: merchantsByName, showList: true });
            }
            // console.log(' filterByName merchantsByName==',merchantsByName)
        }
    }
    onSelect(item, isHidePopup) {
        this.setState({ search_value: item.name, showList: false, merchantsByName: [] });
        if (isHidePopup) {
            this.props.onShowMerchantsNearYou();
        }
        this.props.onSelectMerchant(item);
    }
    handleChange = address => {
        this.setState({ search_value: address })
        if (this.state.selectSearch !== 'google') {
            this.filterByName(address);
        }
    };
    handleSelect = address => {
        this.setState({ search_value: address })
        geocodeByAddress(address)
            .then(results => {
                // console.log('handleSelect results=', results)
                this.props.onSearchPlace(results[0])
            })
            .catch(error => console.error('Error', error));
    };
    onSelectAddress(add) {
        console.log("AAA add:", add)
        this.setState({ search_value: add.address })
        this.props.resetMerchant()
        this.props.onSearchPlace(add)
    }
    onSelectSearchChange(value) {
        console.log('select change = ', value)
        this.setState({ selectSearch: value })
    }
    render() {

        const { open, classes, t, filter_options, filterSelected, onSelectFilter, onClearFilter,
            isLoadedCurrentLocation, merchants, offers, onCloseMap, zoomMap, showLoading,
            onShowCurrentLocation, onSelectMerchant, onOpenFilter, onShowOfferDetail, centerRegion } = this.props;


        return (
            // <Container showLoading={showLoading}>
            <Grid item xs={12} container className={classes.root}>
                <Grid container item xs={12} className={classes.content}>
                    <MapCompomentFull classes={classes} t={t}
                        merchants={merchants}
                        offers={offers}
                        onCloseMap={onCloseMap}
                        zoomMap={zoomMap}
                        onSelectMerchant={onSelectMerchant}
                        onOpenFilter={onOpenFilter}
                        onShowOfferDetail={onShowOfferDetail}
                        centerRegion={centerRegion}
                        markerSelected={this.state.markerSelected}
                        onSelectMerchant2={this.onSelectMerchant}
                        search_value={this.state.search_value}
                        showList={this.state.showList}
                        onSelectMaker={this.onSelectMaker}
                        onShowRightDrawer={this.onShowRightDrawer}
                        openRightDrawer={this.state.openRightDrawer}
                        onHandleChange={this.onHandleChange}
                        merchantsByName={this.state.merchantsByName}
                        onSelect={this.onSelect}
                        onDirection={this.props.onDirection}
                        handleChange={this.handleChange}
                        onSelectAddress={this.onSelectAddress}
                        selectSearch={this.state.selectSearch}
                        onSwitchSearchArea={this.onSwitchSearchArea}
                        searchSeleactData={this.state.searchSeleactData}
                        onSelectSearchChange={this.onSelectSearchChange} />
                    {/* </Hidden> */}
                </Grid>
                {showLoading && <Loading showLoading={showLoading} />}
            </Grid>
            // </Container>
        );
    }
}
function MapCompomentFull(props) {
    const { classes, t, merchants, offers, onCloseMap, zoomMap, onSelectMerchant, onOpenFilter, onShowOfferDetail, centerRegion, markerSelected,
        onSelectMerchant2, openRightDrawer, onShowRightDrawer, search_value, showList, onSelectMaker, onHandleChange, merchantsByName, onSelect } = props
    console.log('merchants======', merchants)
    let width = window.innerWidth
    //console.log('width===',width)
    let number = (width * 40 / 100) / 400;
    let naturalSlideHeight = 40
    if (width < 1280) {
        number = (width * 50 / 100) / 400;
    }
    else if (width < 600) {
        number = width / 500;
        // naturalSlideHeight = 10
    }
    return (
        <Grid xs={12} item container className={classes.map_small}>
            <DrawerCustom open={openRightDrawer} onClose={onShowRightDrawer} fullScreen
                children={
                    <Grid item className={classes.drawerRight}>
                        <Grid xs={12} item container className={classes.search} alignContent='center'>
                            <Select
                                disableUnderline
                                className={classes.selectBox}
                                defaultValue={props.searchSeleactData[0].value}
                                value={props.selectSearch}
                                onChange={(event) => props.onSelectSearchChange(event.target.value)}
                                IconComponent={ArrowDownIcon}
                                classes={{ select: classes.selectCustom, icon: classes.selectCustomIcon }}
                            >
                                {props.searchSeleactData.map((item, index) => {
                                    return <MenuItem value={item.value}><CustomTypo>{item.label}</CustomTypo></MenuItem>
                                })}
                            </Select>
                            <MapInputComponent
                                isSelectBox
                                onHandleChange={props.selectSearch !== 'google' ? props.onHandleChange : undefined}
                                onSelectAddress={props.onSelectAddress}
                                defaultAddress={props.search_value}
                            />
                            {portal_config[domainName].isOfferFilter && <TuneIcon className={classes.tune} onClick={() => onOpenFilter()} />}

                            {showList && merchantsByName.length > 0 ? <Grid xs={12} item container><List className={classes.search_list}>
                                {merchantsByName.map((item, index) => (
                                    <ListItem button key={index} onClick={() => onSelect(item)}>
                                        <ListItemText primary={item.name} />
                                    </ListItem>))}

                            </List></Grid> : null}

                        </Grid>
                        {offers && <Grid xs={12} item>
                            <CustomTypo mg_top_xl light variant='caption1'>{t('text_title_to_be_replace')}</CustomTypo>
                            <CarouselProvider
                                naturalSlideWidth={100}
                                naturalSlideHeight={naturalSlideHeight}
                                totalSlides={offers.length}
                                visibleSlides={number}
                                isPlaying={true}
                                interval={2000}
                                touchEnabled={true}
                                dragEnabled={false}
                            >
                                <Slider>
                                    {offers.map((item, index) =>
                                        <Slide index={index}><OfferItem key={index} item={item} classes={classes} onClick={() => onShowOfferDetail(item)} onShowOfferDetail={onShowOfferDetail} /></Slide>
                                    )}
                                </Slider>
                            </CarouselProvider>
                        </Grid>}
                        {merchants && <Grid xs={12} item>
                            <CustomTypo mg_top_xl light variant='caption1'>{t('merchant_near_you')}</CustomTypo>
                            <Grid xs={12} item  >
                                {merchants.map((item, index) =>
                                    <MerchantItem key={index} item={item} classes={classes} onSelectMerchant={onSelectMerchant} onDirection={props.onDirection} />
                                )}
                            </Grid>
                        </Grid>}
                    </Grid>
                }

            />

            <GoogleMapComponent center={centerRegion} zoom={zoomMap}>
                {merchants ? merchants.map((venue, index) => {
                    var location = venue.location;
                    var address = location.address
                    if (location && location.lat && location.lon) {

                        return (
                            <GoogleMapMarker
                                info={{ title: venue.name, description: address, id: venue.id, contact_info: venue.contact_info }}
                                key={index}
                                lat={location.lat}
                                lng={location.lon}
                                onClick={onSelectMaker}
                                markerSelected={markerSelected}
                                onSelect={() => onSelectMerchant2(venue)}
                            />
                        )
                    }
                }) : null}
            </GoogleMapComponent>
            {/* <Grid Grid xs={12} item container className={classes.footer}> */}
            <Grid item className={classes.toc_bg} onClick={() => onShowRightDrawer()} container justify='center' alignItems='center' id="btn_map_filter">
                <TocIcon />
            </Grid>
            {/* </Grid> */}
        </Grid>
    )
}

function MerchantItem(props) {
    const { classes, item, onSelectMerchant, onDirection } = props

    var distance = item.location && item.location.distance ? item.location.distance.toFixed(2) : null;
    var address = item.location && item.location.address ? item.location.address : "";
    var phone_number = null;
    var email = null;
    // item.contact_info = [
    //     { type:'EMAIL', value:'hongdthaui@gmail.com'},
    //     { type:'PHONE', value:'123456'},
    // ]
    if (item.contact_info) {
        item.contact_info.forEach((item) => {
            if (item.type === 'PHONE') {
                phone_number = item.value;
            }
            else if (item.type === 'EMAIL') {
                email = item.value;
            }
        })
    }

    var covertToKM = 0;
    if (distance)
        covertToKM = distance * 1.6;
    if (covertToKM)
        covertToKM = covertToKM.toFixed(2);

    return (
        <Grid xs={12} item container onClick={() => onSelectMerchant(item)} className={classes.cursor}>
            <Grid xs={3} sm={2} item container justify='center' alignItems='center'>
                <MerchantItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_detail_merchant)} />
            </Grid>
            <Grid xs={9} sm={10} item className={classes.merchant_right} container>
                <Grid item xs={11}>
                    <Grid xs={12} item >
                        <CustomTypo variant='subtitle2' light>{item.name}</CustomTypo>
                    </Grid>
                    {address ? <Grid xs={12} item >
                        <CustomTypo variant='description' light>{address}</CustomTypo>
                    </Grid> : null}
                    {phone_number ?
                        <CustomTypo variant='description' light>{phone_number}</CustomTypo>
                        : null}
                    {email ?
                        <CustomTypo variant='description' light>&nbsp;•&nbsp;{email}</CustomTypo>
                        : null}
                    {distance ?
                        <CustomTypo variant='description' light >&nbsp;•&nbsp;{covertToKM} km ({distance} mi)</CustomTypo>
                        : null}

                </Grid>
                <Grid item xs={1} container justify='flex-end' onClick={() => onDirection(item.location)} className={classes.google_map}>
                    <GoogleMapIcon />
                </Grid>
                <Grid item xs={12}>
                    <hr />
                </Grid>

            </Grid>

        </Grid>


    )
}

function MerchantItemImage(props) {
    const { classes, image } = props;

    if (image) {
        return <img src={image.url} className={classes.merchant_image} />
    } else {
        return (
            <div>
            </div>
            // <View style={home_styles.item_container_icon}>
            //     <GiftIcon style={[main_styles.icon_large, main_styles.icon_color_disable]} />
            // </View>
        )
    }
}
function OfferItem(props) {
    const { classes, item } = props


    return (
        <div className={classes.item_container}>
            {/* <Grid xs={12} sm={12} md={6} item container direction = 'row' > */}
            <Grid xs={12} item container className={classes.item} onClick={() => props.onShowOfferDetail(item)}>
                <Grid xs={4} xl={4} item container>
                    <OfferItemImage classes={classes} image={dataUtil.getImageByUsageTypePortal(item.creatives, usage_type.offer_detail)} />
                </Grid>
                <Grid xs={8} xl={8} item container className={classes.item_right}>
                    {item.industry_name && <Grid xs={12} >
                        <div className={classes.tag}>
                            <CustomTypo variant='body2' color='tertiary'>{item.industry_name}</CustomTypo>
                        </div>
                    </Grid>}
                    <Grid xs={12} item container>
                        <CustomTypo variant='h6'>{item.owned_by.name}</CustomTypo>
                    </Grid>
                    <Grid xs={12} item container>
                        <CustomTypo variant='body2' color='danger'>{item.name}</CustomTypo>
                    </Grid>
                </Grid>
            </Grid>
            {/* </Grid> */}
        </div>

    )
}


function OfferItemImage(props) {
    const { classes, image } = props;

    if (image) {
        return <img src={image.url} className={classes.item_image} />
    } else {
        return (
            <div>
            </div>
            // <View style={home_styles.item_container_icon}>
            //     <GiftIcon style={[main_styles.icon_large, main_styles.icon_color_disable]} />
            // </View>
        )
    }
}
export default withStyles(styles)(withTranslation()(MapView));